/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiScenarioIntervalTimeUnit } from './InternalApiScenarioIntervalTimeUnit';
import {
    InternalApiScenarioIntervalTimeUnitFromJSON,
    InternalApiScenarioIntervalTimeUnitFromJSONTyped,
    InternalApiScenarioIntervalTimeUnitToJSON,
    InternalApiScenarioIntervalTimeUnitToJSONTyped,
} from './InternalApiScenarioIntervalTimeUnit';

/**
 * 
 * @export
 * @interface InternalApiPeriodicScenarioAttributes
 */
export interface InternalApiPeriodicScenarioAttributes {
    /**
     * 
     * @type {Date}
     * @memberof InternalApiPeriodicScenarioAttributes
     */
    startTime: Date;
    /**
     * 
     * @type {number}
     * @memberof InternalApiPeriodicScenarioAttributes
     */
    periodicInterval: number;
    /**
     * 
     * @type {InternalApiScenarioIntervalTimeUnit}
     * @memberof InternalApiPeriodicScenarioAttributes
     */
    periodicIntervalTimeUnit: InternalApiScenarioIntervalTimeUnit;
}



/**
 * Check if a given object implements the InternalApiPeriodicScenarioAttributes interface.
 */
export function instanceOfInternalApiPeriodicScenarioAttributes(value: object): value is InternalApiPeriodicScenarioAttributes {
    if (!('startTime' in value) || value['startTime'] === undefined) return false;
    if (!('periodicInterval' in value) || value['periodicInterval'] === undefined) return false;
    if (!('periodicIntervalTimeUnit' in value) || value['periodicIntervalTimeUnit'] === undefined) return false;
    return true;
}

export function InternalApiPeriodicScenarioAttributesFromJSON(json: any): InternalApiPeriodicScenarioAttributes {
    return InternalApiPeriodicScenarioAttributesFromJSONTyped(json, false);
}

export function InternalApiPeriodicScenarioAttributesFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiPeriodicScenarioAttributes {
    if (json == null) {
        return json;
    }
    return {
        
        'startTime': (new Date(json['startTime'])),
        'periodicInterval': json['periodicInterval'],
        'periodicIntervalTimeUnit': InternalApiScenarioIntervalTimeUnitFromJSON(json['periodicIntervalTimeUnit']),
    };
}

export function InternalApiPeriodicScenarioAttributesToJSON(json: any): InternalApiPeriodicScenarioAttributes {
    return InternalApiPeriodicScenarioAttributesToJSONTyped(json, false);
}

export function InternalApiPeriodicScenarioAttributesToJSONTyped(value?: InternalApiPeriodicScenarioAttributes | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'startTime': value['startTime'].toISOString(),
        'periodicInterval': value['periodicInterval'],
        'periodicIntervalTimeUnit': InternalApiScenarioIntervalTimeUnitToJSON(value['periodicIntervalTimeUnit']),
    };
}

